import Api from './api/Calendar';
window.toggleSubElements = function (el) {
    const divTree = el.closest('li').querySelector('div.tc-history-info');
    const icon = el.querySelector('span.fas');
    if (divTree.className === 'hidden-div tc-history-info') {
        icon.className = 'fas fa-caret-right fa-smooth-rotate-90 animate-300';
        divTree.className = 'tc-history-info animate-300';
    } else {
        divTree.className = 'hidden-div tc-history-info';
        icon.className = 'fas fa-caret-right animate-300';
    }
}

window.cancelActivity = function (el) {
    const warningDisplayed = parseInt(el.dataset.warningDisplayed);
    if (warningDisplayed === 0) {
        el.textContent = $t('Er du sikker?');
        el.className = el.className.replace('btn-secondary', 'btn-danger');
        el.dataset.warningDisplayed = 1;
        return;
    }

    el.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + $t('Er du sikker?');
    el.setAttribute('disabled', 'disabled');

    const calendarId = el.dataset.calendarId;

    Api.CancelBooking(calendarId).then(function (res) {
        if (res.success) {
            el.className = el.className.replace('btn-danger', 'btn-success');
            el.textContent = $t('Denne aktiviteten er nå avbestilt.');


            window.setTimeout(function () {
                const wrapperEl = document.getElementById('calendar-id-' + calendarId)
                if (wrapperEl && wrapperEl.classList) {
                    wrapperEl.classList.add('fade-out');
                }

                window.setTimeout(function () {
                    if (wrapperEl && wrapperEl.classList) {
                        wrapperEl.classList.add('d-none');
                    }
                }, 400);
            }, 5000);
            return;
        }

        // Booking not cancelled, show message
        const errorAlert = document.querySelector('.alert-cancel-feedback[data-calendar-id="' + calendarId + '"]');
        errorAlert.className = errorAlert.className.replace('d-none', '');
        errorAlert.innerHTML = res.message;

        el.className += ' d-none';

    }).catch(function (error) {
        // Booking not cancelled, show message
        const errorAlert = document.querySelector('.alert-cancel-feedback[data-calendar-id="' + calendarId + '"]');
        errorAlert.className = errorAlert.className.replace('d-none', '');
        errorAlert.textContent = $t('Oops, her skjedde det noe galt. Prøv igjen senere eller ta kontakt med trafikkskolen for å kansellere.');

        el.className += ' d-none';
        console.error(error);
    })
}
